import {Rule} from 'antd/lib/form';
import {useCallback, useEffect, useMemo, useState} from 'react';

import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {CompanyKeyEnum} from '../../../../../../../service/company-v2/company-const';
import {CompanyFormType} from '../../../../../../../service/company-v2/company-type';
import {Form, FormInstance} from '../../../../../../../typings/antd';
import {getOpeningDateRequiredRule, hasOpeningDate} from '../opening-soon-form-item/opening-soon-form-item-helper';

type ResultType = {
    handleOpeningSoonSwitchChange: (checked: boolean) => void;
    isOpeningSoonSwitchOn: boolean;
    openingDateRules: Array<Rule>;
};

export function useOpeningSoonFormItem(): ResultType {
    const form = Form.useFormInstance<CompanyFormType>();
    const openingDate = Form.useWatch<CompanyKeyEnum.OpeningDate, FormInstance<CompanyFormType>>(
        CompanyKeyEnum.OpeningDate
    );
    const {getLocalizedString} = useLocale();
    const [isOpeningSoonSwitchOn, setIsOpeningSoonSwitchOn] = useState(() =>
        hasOpeningDate(form.getFieldValue(CompanyKeyEnum.OpeningDate))
    );

    useEffect(() => {
        if (hasOpeningDate(openingDate)) {
            setIsOpeningSoonSwitchOn(true);
        }
    }, [openingDate]);

    const handleOpeningSoonSwitchChange = useCallback(
        (checked: boolean) => {
            setIsOpeningSoonSwitchOn(checked);

            if (!checked) {
                form.setFieldsValue({[CompanyKeyEnum.OpeningDate]: null});
            }
        },
        [form]
    );

    const isOpeningSoonEnabled = isOpeningSoonSwitchOn || hasOpeningDate(openingDate);

    const openingDateRules = useMemo(
        () => [getOpeningDateRequiredRule(() => isOpeningSoonEnabled, getLocalizedString)],
        [getLocalizedString, isOpeningSoonEnabled]
    );

    return {
        handleOpeningSoonSwitchChange,
        isOpeningSoonSwitchOn,
        openingDateRules,
    };
}
